/* eslint-disable import/prefer-default-export */
import React from 'react';
import { eq, createFilter } from 'store/Filters/constants';
import useFilterToggle from 'Hooks/useFilterToggle';
import get from 'lodash/get';
import { TagWrapper, TagStyles } from './styled';

export const TagCell = ({ rowInfo, onAsset = false }) => {
  const tags = get(rowInfo, 'original.tags', []);
  return (
    <>
      {
          tags.map((tag) => (
            <Tag key={ `tag_manage_table_${tag}` } tag={ tag } onAsset={ onAsset } />
          ))
        }
    </>
  );
};

const Tag = ({ tag, onAsset }) => { // eslint-disable-line import/prefer-default-export
  const filter = createFilter('tags__name', eq.name.value, tag);
  const [isFilterActive, toggleFilter] = useFilterToggle(filter, 'vulns');
  const [isFilterActiveVulnsAsset, toggleFilterVulnsAsset] = useFilterToggle(filter, 'vulnsAssets');

  return (
    <TagWrapper className="mr-2 tag" onClick={ onAsset ? toggleFilterVulnsAsset : toggleFilter } state={ onAsset ? isFilterActiveVulnsAsset : isFilterActive }>
      <TagStyles>{tag}</TagStyles>
    </TagWrapper>
  );
};
